function subtractMoneyStrings(moneyString1, moneyString2) {
  const number1 = parseFloat(moneyString1.replace(/[^0-9.,-]/g, ''));
  const number2 = parseFloat(moneyString2.replace(/[^0-9.,-]/g, ''));

  const result = number1 - number2;

  const formattedResult = result.toLocaleString('en-US', {
    style: 'currency',
    currency: 'GBP',
    currencyDisplay: 'symbol'
  });

  return formattedResult;
}

function multiplyMoneyString(priceWithCurrency, multiplier) {
  const number = parseFloat(priceWithCurrency.replace(/[^0-9.,-]/g, ''));
  const result = number * multiplier;

  const formattedResult = result.toLocaleString('en-US', {
    style: 'currency',
    currency: 'GBP',
    currencyDisplay: 'symbol'
  });

  return formattedResult;
}

function calculatePercentageRoundedUp(smallerValue, largerValue) {
  const smallerNumber = parseFloat(smallerValue.replace(/[^0-9.,-]/g, ''));
  const largerNumber = parseFloat(largerValue.replace(/[^0-9.,-]/g, ''));

  const percentage = Math.ceil((smallerNumber / largerNumber) * 100);

  return percentage;
}

function sumMoneyStrings(moneyStrings) {
  if (moneyStrings.length === 0) {
    return '£0.00'; 
  }

  const numbers = moneyStrings.map(moneyString => parseFloat(moneyString.replace(/[^0-9.,-]/g, '')));
  const total = numbers.reduce((acc, curr) => acc + curr, 0);

  const formattedTotal = total.toLocaleString('en-US', {
    style: 'currency',
    currency: 'GBP',
    currencyDisplay: 'symbol'
  });

  return formattedTotal;
}

function getPrice(parentElement) {
  const productPriceElement = parentElement.querySelector('.cart__price');
  const hiddenSpan = productPriceElement.querySelector('.visually-hidden');

  const rawPrice = hiddenSpan ? hiddenSpan.textContent : productPriceElement.textContent;

  const formattedPrice = rawPrice.replace(/[^\d.,£€$¥.]/g, '');
  
  const dotFormattedPrice = formattedPrice.includes('.') ? formattedPrice : formattedPrice.replace(/(\d{2})$/, '.$1');
  
  return dotFormattedPrice;
}

function getPriceListByVendor(vendor){
  const lineItemsVendor = document.querySelectorAll(`[data-cart-item-vendor="${vendor}"]`)
  const moneyArray = []

  lineItemsVendor.forEach((lineItem)=>{
    const itemPrice = getPrice(lineItem)
    const itemQuantity = Number(lineItem.querySelector('.js-qty__num').value)
    if(itemPrice && itemQuantity){
      const finalPrice = multiplyMoneyString(itemPrice, itemQuantity)
      moneyArray.push(finalPrice)
    }
  })

  return moneyArray
}

function getTotalPricePerVendor(vendor){
  const priceList = getPriceListByVendor(vendor)
  const totalPrice = sumMoneyStrings(priceList)

  return totalPrice
}

function getVendorFreeShippingPercentage(vendor){
  const vendorTotalPrice = getTotalPricePerVendor(vendor)
  const vendorShippingRate = checkIfVendorHasFreeShipping(vendor)

  if(vendorTotalPrice && vendorShippingRate){
    return calculatePercentageRoundedUp(vendorTotalPrice, vendorShippingRate.split('//')[1])
  }
}

function getVendorFreeShippingAmount(vendor){
  const vendorTotalPrice = getTotalPricePerVendor(vendor)
  const vendorShippingRate = checkIfVendorHasFreeShipping(vendor)

  if(vendorTotalPrice && vendorShippingRate){
    return subtractMoneyStrings(vendorShippingRate.split('//')[1], vendorTotalPrice)
  }
}

function checkIfVendorHasFreeShipping(vendor) {
  const freeShippingElement = document.querySelector('[data-vendor-free-shippings]');
  
  if (freeShippingElement) {
    const freeShippingDatabase = freeShippingElement.getAttribute('data-vendor-free-shippings');
    return (freeShippingDatabase && freeShippingDatabase.split('||').find(freeShippingItem => freeShippingItem.includes(vendor))) || false;
  } 

  return false;
}

function getTotalShippingAmount (vendor){
  const vendorShippingAmount = checkIfVendorHasFreeShipping(vendor)

  if(vendorShippingAmount){
    return vendorShippingAmount.split('//')[2]
  }
}

function getTimeShipping (vendor){
  const vendorShippingValues = checkIfVendorHasFreeShipping(vendor)

  if(vendorShippingValues){
    return vendorShippingValues.split('//')[3]
  }
}

function hasQueryParameters(url) {
  const queryParamRegex = /[?&][A-Za-z]=[^&#]*/g;
  return queryParamRegex.test(url);
}

function getVendorImageURL(vendor){
  const vendorImagesElement = document.querySelector('[data-vendor-thumb-images]')
  if(vendorImagesElement){
    const vendorImagesDatabase = vendorImagesElement.getAttribute('data-vendor-thumb-images')
    return (vendorImagesDatabase && vendorImagesDatabase.split('||').find(vendorImagesItem => vendorImagesItem.includes(vendor))) || false;
  }

  return false;
}

function validateVendorImageURL(vendor){
  const vendorImageUrl = getVendorImageURL(vendor)
  if(vendorImageUrl){
    if(hasQueryParameters(vendorImageUrl)){
      return vendorImageUrl.split(';;')[1];
    }else{
      return false;
    }
  }
  return false;
}

function getFreeShippingCTA(vendor, shippingAmount, totalShipping) {
  const elementFreeShippingCTA = document.querySelector('[data-vendor-free-shipping-cta]');
  
  if (elementFreeShippingCTA) {
    const elementFreeShippingCTAValue = elementFreeShippingCTA.getAttribute('data-vendor-free-shipping-cta');

    const replacedValue = elementFreeShippingCTAValue
      .replace('{{ money }}', shippingAmount)
      .replace('{{ vendor }}', `<b>${vendor}</b>`)
      .replace('{{ fee }}', `<b>${totalShipping}</b>`);

    return replacedValue;
  }

  return '';
}

function getFreeShippingCompleted(vendor) {
  const elementFreeShippingCompleted = document.querySelector('[data-vendor-free-shipping-completed]');
  
  if (elementFreeShippingCompleted) {
    const elementFreeShippingCompletedValue = elementFreeShippingCompleted.getAttribute('data-vendor-free-shipping-completed');

    const replacedValue = elementFreeShippingCompletedValue
      .replace('{{ vendor }}', `<b>${vendor}</b>`);

    return replacedValue;
  }

  return '';
}

function urlForVendor(vendor) {
  if (!vendor) return null;
  
  // Codifica corretamente o nome do fornecedor para uso seguro na URL
  const encodedVendor = encodeURIComponent(vendor);
  
  // Retorna a URL no formato correto
  return `/collections/vendors?q=${encodedVendor}`;
}

function injectFreeShippingBar(){
  const vendorsBlock = document.querySelectorAll('.cart__items-vendor')

  vendorsBlock.forEach((vendorBlock) =>{
    const vendor = vendorBlock.getAttribute('data-vendor-group')
    const isFreeShipping = checkIfVendorHasFreeShipping(vendor)

    if(isFreeShipping){
      var newDivProgressShipping = document.createElement('div');
      const shippingPercentage = getVendorFreeShippingPercentage(vendor)
      const totalShippingAmount = getTotalShippingAmount(vendor)
      const timeShipping = getTimeShipping(vendor)
      const shippingAmount = getVendorFreeShippingAmount(vendor)
      newDivProgressShipping.className = shippingPercentage >= 100 ? 'cart__shipping-bar-wrapper cart__shipping-bar-wrapper--completed' :'cart__shipping-bar-wrapper cart__shipping-bar-wrapper--in-progress';
      newDivProgressShipping.dataset.vendor = urlForVendor(vendor);
      newDivProgressShipping.dataset.vendorName = vendor;
      const vendorImageUrl = validateVendorImageURL(vendor)
      const freeShippingCTA = getFreeShippingCTA(vendor, shippingAmount, totalShippingAmount)
      const freeShippingCompleted = getFreeShippingCompleted(vendor)
      const vendorFallbackSvg = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-plant icon--line" viewBox="0 0 100 100" width="20" height="20"><path d="M15.33 86.58h69.34s-30.67-40.37-69.34 0Z" fill="none" stroke="currentColor"></path><path d="M43.15 46.69s9 8.83 9.27 22m29.64-55.26s-27.38-1.32-25.37 25.16c0 0 23 5.54 25.37-25.16m0 0L56.69 38.59m6.5-6.42 13.16-.45m-6.3-6.37 9.7-.34m-16.56 7.16.45-13.07m6.41 6.25.34-9.91" fill="none" stroke="currentColor"></path><path d="M50.64 59.11a32.68 32.68 0 0 1 6-20.52M18 21.31S16.67 48.7 43.15 46.69c0 0 5.54-23-25.15-25.38m-.01 0 25.16 25.38m-6.42-6.5-.45-13.16m-6.37 6.3-.34-9.7m7.16 16.56-13.08-.45m6.26-6.41L20 32.99" fill="none" stroke="currentColor"></path></svg>'

      newDivProgressShipping.innerHTML = `
      <p>${shippingPercentage >= 100 ? freeShippingCompleted : freeShippingCTA}</p>
      <div class="cart__shipping-info-bar-wrapper">
        <div class="cart__shipping-bar-info">
          ${vendorImageUrl ? `<img src="${vendorImageUrl}" width="20" height="20" onerror="this.style.display='none';this.nextElementSibling.style.display=''" /><span style="display:none">${vendorFallbackSvg}</span>` : vendorFallbackSvg}
          <p><b>${vendor}</b></p>
        </div>
        <div class="cart__shipping-bar">
          <div class="cart__progress-bar" style="width:${shippingPercentage > 100 ? 100 : shippingPercentage}%"></div>
          <div class="cart__progress-bar-bg"></div>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><rect width="20" height="20" x="1" y="1" fill="#fff" rx="10"/><rect width="20" height="20" x="1" y="1" stroke="#134A44" rx="10"/><path stroke="#000" stroke-width="1.5" d="m17 7-6.965 7L6 9.973"/></svg>
        </div>
      </div>
      `;

      // The thumbnail files in Shopify Files may not exist for every vendor
      // (file_url can't tell us — it stamps ?v= on missing files too), so the
      // img carries an inline onerror that reveals the hidden fallback icon.
      // Kept as an attribute, not addEventListener: the attribute survives the
      // innerHTML re-serialization below, a JS-attached listener does not.

        async function getUKHolidays(year) {
          try {
            const response = await fetch(`https://date.nager.at/api/v2/publicholidays/${year}/gb`);
            const holidaysData = await response.json();
            const ukHolidays = holidaysData.map(holiday => holiday.date);
    
            return ukHolidays;
          } catch (error) {
            // console.error('Error getting UK holidays:', error);
            return [];
          }
        }
    
        function isUKHoliday(date, ukHolidays) {
          return ukHolidays.includes(date.toString('yyyy-MM-dd'));
        }
  
        const currentYear = new Date().getFullYear();
        getUKHolidays(currentYear)
          .then(ukHolidays => {
            let timeShippingParts = timeShipping ? timeShipping.split('-') : ["2", "4"];
            let initialDay = parseInt(timeShippingParts[0]);
            let finalDay = parseInt(timeShippingParts[1]);
            let businessDaysToAdd = finalDay - initialDay;
            let fromDateCart = Date.today().addDays(initialDay);
  
            function adjustDeliveryDate(date) {
              while (date.is().sunday() || date.is().monday() || isUKHoliday(date, ukHolidays)) {
                date = date.next().day();
              }
              return date;
            }
        
            fromDateCart = adjustDeliveryDate(fromDateCart);
        
            let toDateCart = fromDateCart.clone();
            
            while (businessDaysToAdd > 0) {
              toDateCart = toDateCart.next().day();
              if (!toDateCart.is().sunday() && !toDateCart.is().monday() && !isUKHoliday(toDateCart, ukHolidays)) {
                businessDaysToAdd--;
              }
            }
        
            function formatDateAbbreviated(date) {
              const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
              const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            
              const formattedDay = daysOfWeek[date.getDay()].substring(0, 3);
              const formattedMonth = months[date.getMonth()].substring(0, 3);
            
              return `${formattedDay} ${formattedMonth} ${date.getDate()}th`;
            }
            // NOTE: never assign to newDivProgressShipping.innerHTML here (even
            // `+=` of an empty string) — re-serializing recreates the vendor
            // <img> and races against its load/error state.
          });
      
      vendorBlock.appendChild(newDivProgressShipping);
    }
  })
}

function updateVendorInCart(){
  const cartItemsByVendor = document.querySelectorAll('[data-cart-item-vendor]')
  const vendors = []

  cartItemsByVendor.forEach((cartItemByVendor)=>{
    const vendorName = cartItemByVendor.getAttribute('data-cart-item-vendor')
    if(!vendors.includes(vendorName)){
      vendors.push(vendorName)
    }
  })

  const cartItemsList = document.querySelector('.cart__items')

  cartItemsList.innerHTML = ''

  vendors.map((vendor) => {
    var newDivItemsVendor = document.createElement('div');
    newDivItemsVendor.className = 'cart__items-vendor';
    newDivItemsVendor.setAttribute('data-vendor-group', vendor);
    
    cartItemsByVendor.forEach((cartItemByVendor)=>{
      const vendorName = cartItemByVendor.getAttribute('data-cart-item-vendor')
      if(vendorName === vendor){
        newDivItemsVendor.appendChild(cartItemByVendor);
      }
    })
    
    cartItemsList.appendChild(newDivItemsVendor)
  })

  injectFreeShippingBar()

}

document.addEventListener('cart:vendor-order-update', updateVendorInCart);

function productRecommendations() {
  const vendorsContainers = document.querySelectorAll('.cart__shipping-bar-wrapper')
  const vendors = Array.from(vendorsContainers).map(vendorContainer => vendorContainer.dataset.vendor);
  const vendorsName = Array.from(vendorsContainers).map(vendorContainer => vendorContainer.dataset.vendorName);
  
  let currency = theme.currencySymbol;
  
  if (vendors.length > 0) {
      vendors.forEach((vendor, index) => {
          fetchVendorProducts(vendor, index);
      });
  }
  
  async function getCartIds() {
    const cartIds = [];
    await fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        data.items.forEach(item => {
          cartIds.push(item.product_id);
        });
      })
      .catch(error => console.error("Erro ao buscar ids do carrinho:", error));
    return cartIds;
  }
  
  async function fetchVendorProducts(vendor, index) {
        let cartProductIds = await getCartIds();
        fetch(`${vendor}&view=vendor-json`,
        )
          .then(response => response.text())
          .then(data => {
              const dataJSON = JSON.parse(data);
              console.log(dataJSON);
              const collection = dataJSON.collection;
              if (collection.products.length > 0) {
                  let filteredProducts = collection.products
                    .filter(product => !cartProductIds.includes(product.id))
                    .filter(product => product.available == "true")
                    .slice(0, 4);
  
                  var productsHtml = `
                    <div class="cart__item-row cart-recommendations">
                      <div class="h3 h3--mobile cart__recommended-title">More from ${vendorsName[index]}</div>
                      <div id="recommended-products" class="new-grid product-grid scrollable-grid--small">`
  
                  if (filteredProducts.length > 0) {
                      productsHtml += filteredProducts.map(product => `
                          <div class="grid-item grid-product grid-product-image-breathing-room--true grid-product--gridlines overlay">
                            <div class="product-grid-item" data-product-handle="${product.handle}" data-product-id="${product.id}" data-product-grid-item="">
                              <div class="grid-item__content">
                                <div class="grid-product__actions">
                                  <quick-shop>
                                    <tool-tip-trigger class="tool-tip-trigger" data-tool-tip="QuickShop" data-tool-tip-classes="quick-shop-modal">
                                      <span class="tool-tip-trigger__content" data-tool-tip-trigger-content=""></span>
                                      <button type="button" class="btn btn--circle btn--icon quick-product__btn js-modal-open-quick-modal-${product.id} small--hide" title="Quick shop" data-handle="${product.handle}">
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-search icon--line" viewBox="0 0 64 64" width="20" height="20">
                                          <path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58M54 54 41.94 42" stroke-miterlimit="10" fill="none" stroke="currentColor"></path>
                                        </svg>
                                        <span class="icon__fallback-text visually-hidden">Quick shop</span>
                                      </button>
                                    </tool-tip-trigger>
                                  </quick-shop>
                                  <quick-add>
                                    <tool-tip-trigger class="tool-tip-trigger" data-tool-tip="QuickAdd">
                                      <span class="tool-tip-trigger__content" data-tool-tip-trigger-content=""></span>
                                      <button type="button" class="text-link quick-add-btn" title="Add to cart" data-id="${product.variants[0].id}" data-single-variant-quick-add="">
                                        <span class="btn btn--circle btn--icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus icon--line" viewBox="0 0 64 64" width="20" height="20"><path d="M32 9v46m23-23H9" fill="none" stroke="currentColor"></path></svg>
                                          <span class="icon__fallback-text visually-hidden">Add to cart</span>
                                        </span>
                                      </button>
                                    </tool-tip-trigger>
                                  </quick-add>
                                </div>
  
                                <a href="${product.url}" class="grid-item__link">
                                  <div class="grid-product__image-wrap">
                                    <div class="grid-product__tags"></div>
                                    <div class="grid__image-ratio grid__image-ratio--square">
                                      <img src="${product.featured_image}" alt="${product.title}" width="900" height="900.0" loading="lazy" class="image-style--square image-element" sizes="30vw" data-animate="fadein">
                                    </div>
                                  </div>
  
                                  <div class="grid-item__meta">
                                    <div class="grid-item__meta-main">
                                      <div class="grid-product__title">${product.title}</div>
                                      <div class="grid-product__vendor">${product.vendor}</div>
                                    </div>
                                    <div class="grid-item__meta-secondary">
                                      <div class="grid-product__price">
                                        <span class="grid-product__price--current">
                                          <span aria-hidden="true" class="grid-product__price--from">
                                            ${currency} ${product.price / 100}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                      `).join("");
  
                      productsHtml += "</div></div>";
                      // insert after the vendor container
                      vendorsContainers[index].insertAdjacentHTML('afterend', productsHtml);
                    
                      rehydrateComponents();
                  }
              }
          })
          .catch(error => console.error("Erro ao buscar recomendações:", error));
  }
  
  function rehydrateComponents() {
      Promise.all([
          import("components/tool-tip-trigger"),
          import("components/quick-shop"),
          import("components/quick-add")
      ]).then(() => {
          console.log("Components rehydrated");
      }).catch(err => console.error("Error rehydrating components:", err));
  }
}

document.addEventListener('cart:vendor-order-update', productRecommendations);